module.exports = __webpack_public_path__ + "02_veryshort_brown.a8125a3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_veryshort_brown.png
// module id = uHwo
// module chunks = 0